import React, { useContext, useEffect, useState } from "react";
import BtnSendVerify from "./btnSendVerify";
import { VerifyContext } from "../../pages/verification/verify";
import verifyService from "../../services/verify.service";
import ShowDoc from "../common/showDoc";
import { BaseURL } from "../../constants/enum/baseURL.emum";
import moment from "moment";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";

const VerifyItem = (props: { curri: any }) => {
  const { curri } = props;

  const { form, reCheck, setReCheck } = useContext<any>(VerifyContext);
  const me = useSelector((state: any) => state.me);
  const [pathFile, setPartFile] = useState("");
  const [report, setReport] = useState("");
  const [open, setOpen] = useState(0);
  const [verify, setVerify] = useState(0);
  const [percentage, setPercentage] = useState(0);
  const [verifyID, setVerifyID] = useState(0);

  // setStatus = useState<boolean>(Boolean(Math.round(Math.random())));
  const [status, setStatus] = useState<boolean>(false);
  ////////////////////////////////////////////////////////////////
  const type = form.type === "มคอ." ? "tqf" : "mhesi";
  useEffect(() => {
    (async () => {
      await verifyService
        .getdata({
          type,
          year: form.year,
          curriculum: curri.id,
        })
        .then((res) => {
          if (res.data) {
            setPartFile(res.data.pathFile);
            setReport(res.data.report);
            setOpen(res.data.open);
            setVerify(res.data.verify);
            setVerifyID(res.data.id);
            setPercentage(res.data.percentage);
            setStatus(true);
            //แสดงว่าส่งแล้ว
          }

          setReCheck(false);
        });
    })();
  }, [curri.id, form.year, type, status, reCheck, setReCheck]);

  ////////////////////////////////////////////////////////////////
  const onDelete = async () => {
    Swal.fire({
      title: "คุณต้องการลบ?",
      // text: `ผลการทวนสอบ ${form.type} \n หลักสูตร ${curri.name} ประจำปีการศึกษา ${form.year}!`,
      html: `ผลการทวนสอบ ${form.type} <br> หลักสูตร ${curri.name} <br>ประจำปีการศึกษา ${form.year}!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ใช่, ลบเลย!",
      cancelButtonText: "ยกเลิก!",
    }).then((result) => {
      if (result.isConfirmed) {
        verifyService
          .onDelete(verifyID)
          .then(() => {
            Swal.fire(
              "ลบข้อมูลสำเร็จ!",
              `ลบผลการทวนสอบ ${form.type} หลักสูตร ${curri.name} ประจำปีการศึกษา ${form.year}! เรียบร้อย`,
              "success"
            );
            setStatus(false);
          })
          .catch(() => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "มีบางอย่างทำงานผิดปกติ!",
            });
          });
      }
    });
  };
  ////////////////////////////////////////////////////////////////

  //ไปที่ตารางเก็บข้อมูล เอาปีการศึกษา เทอม และหลักสูตรไปค้น ถ้าเจอคือส่งแล้ว

  //useEffect เพื่อไปเช็คก่อนว่าส่งหรือยัง ถ้าส่งแล้ว แสดงปุ่มโช ถ้ายังแสดงปุ่มส่ง
  if (status) {
    return (
      <tr>
        <td className="text-start">{curri.name}</td>
        <td className="text-center">
          {moment(report).add(543, "year").format("DD/MM/yyyy")}
        </td>
        <td className="text-center">{open}</td>
        <td className="text-center">{verify}</td>
        <td className="text-center">{percentage}</td>
        <td className="text-center">
          <ShowDoc
            btnName={"ผลการทวนสอบ"}
            url={`${BaseURL.BASE_URL}/upload/verify/${type}/${pathFile}`}
          />
          {me.role === "Admin" && (
            <button className="ms-1 btn btn-danger btn-sm" onClick={onDelete}>
              ลบ
            </button>
          )}
        </td>
      </tr>
    );
  } else {
    return (
      <tr>
        <td className="text-start" colSpan={2}>{curri.name}</td>

        <td className="text-start text-center" colSpan={4}>
          {me.role === "Admin" && <BtnSendVerify curri={curri} />}
        </td>
      </tr>
    );
  }
};

export default VerifyItem;
